var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-view__groups",style:({
    paddingTop: `${_vm.bufferStartIndex * _vm.rowHeight}px`,
  })},_vm._l((_vm.groupByValueSets),function({ groupBy, groupSpans },index){return _c('div',{key:'group-by-' + index,style:({ width: groupBy.width + 'px' })},_vm._l((groupSpans),function(groupSpan,groupSpanIndex){return _c('div',{key:'group-by-span-' + groupSpanIndex,staticClass:"grid-view__group-span",style:({
        height: `${_vm.rowHeight * groupSpan.rowSpan}px`,
      })},[_c('GridViewGroup',{attrs:{"group-by":groupBy,"all-fields-in-table":_vm.allFieldsInTable,"value":groupSpan.value,"count":groupSpan.count}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }